<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('coinsflip.game_config') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ $t('coinsflip.game_config_title') }}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <!-- Percent Group -->
            <v-card class="mb-4" outlined>
              <v-card-title class="text-sm font-weight-light">
                {{ $t('coinsflip.percent_group') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.percent_head"
                      :label="$t('coinsflip.percent_head')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.percent_center"
                      :label="$t('coinsflip.percent_center')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.percent_tail"
                      :label="$t('coinsflip.percent_tail')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Multiply Group -->
            <v-card class="mb-4" outlined>
              <v-card-title class="text-sm font-weight-light">
                {{ $t('coinsflip.multiply_group') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.reward_head_multiply"
                      :label="$t('coinsflip.reward_head_multiply')"
                      type="number"
                      step="0.1"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.reward_center_multiply"
                      :label="$t('coinsflip.reward_center_multiply')"
                      type="number"
                      step="0.1"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.reward_tail_multiply"
                      :label="$t('coinsflip.reward_tail_multiply')"
                      type="number"
                      step="0.1"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Commission Percent Group -->
            <v-card class="mb-4" outlined>
              <v-card-title class="text-sm font-weight-light">
                {{ $t('coinsflip.commission_percent_group') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.commission_web"
                      :label="$t('coinsflip.commission_web')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.commission_company"
                      :label="$t('coinsflip.commission_company')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="configData.commission_other"
                      :label="$t('coinsflip.commission_other')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required]"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Other Game Settings Group -->
            <v-card class="mb-4" outlined>
              <v-card-title class="text-sm font-weight-light pb-2">
                {{ $t('coinsflip.other_game_settings_group') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="d-flex align-center ma-0 pa-0 pb-2" no-gutters>
                    <v-col cols="6" md="3">
                      <v-switch
                        v-model="configData.enabled"
                        :label="$t('coinsflip.enabled_game')"
                        color="success"
                        hide-details
                        inset
                      ></v-switch>
                    </v-col>
                      <v-col cols="6" md="3">
                      <v-switch
                        v-model="configData.open_bot"
                        :label="$t('coinsflip.open_bot')"
                        color="success"
                        hide-details
                        inset
                      ></v-switch>
                    </v-col>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="configData.bet_time"
                      :label="$t('coinsflip.bet_time')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveInteger]"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="configData.min_player"
                      :label="$t('coinsflip.min_player')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveInteger]"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="configData.min_bet"
                      :label="$t('coinsflip.min_bet')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="configData.max_bet"
                      :label="$t('coinsflip.max_bet')"
                      type="number"
                      outlined
                      dense
                      :rules="[rules.required, rules.positiveNumber]"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="saving" @click="saveConfig" :disabled="!valid">
            {{ $t('save') }}
          </v-btn>
          <v-btn color="grey" @click="resetForm">{{ $t('cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import store from '@/store'
import axios from 'axios'

export default {
  name: 'CoinsFlipGameConfig',
  data() {
    return {
      valid: false,
      saving: false,
      configData: {
        percent_head: null,
        percent_center: null,
        percent_tail: null,
        reward_head_multiply: null,
        reward_center_multiply: null,
        reward_tail_multiply: null,
        commission_web: null,
        commission_company: null,
        commission_other: null,
        min_player: 1,
        min_bet: null,
        max_bet: null,
        bet_time: null,
        open_bot: true,
        enabled: false,
      },
      originalConfig: null,
      rules: {
        required: v => (v !== null && v !== undefined && v !== '') || 'This field is required',
        positiveNumber: v => v > 0 || 'Must be greater than 0',
        positiveInteger: v => (Number.isInteger(v) && v > 0) || 'Must be a positive integer',
      },
    }
  },
  async created() {
    await this.addLogPage()
    await this.loadConfig()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(
          res =>
            (data = {
              ip: res.data.ip,
              name: 'ตั้งค่าเกมหัวก้อย',
              url: window.location.href,
              detail: 'ตั้งค่าเกมหัวก้อย',
              admin: userSystem.name ? userSystem.name : '',
            }),
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // Error handling
      }
    },
    async loadConfig() {
      try {
        const res = await this.$store.dispatch('getGameConfig')
        if (res && res.data) {
          this.configData = {
            percent_head: res.data.percent_head || 45,
            percent_center: res.data.percent_center || 10,
            percent_tail: res.data.percent_tail || 45,
            reward_head_multiply: res.data.reward_head_multiply || 1,
            reward_center_multiply: res.data.reward_center_multiply || 10,
            reward_tail_multiply: res.data.reward_tail_multiply || 1,
            commission_web: res.data.commission_web || 95,
            commission_company: res.data.commission_company || 5,
            commission_other: res.data.commission_other || 0,
            min_player: res.data.min_player || 1,
            min_bet: res.data.min_bet || 0.1,
            max_bet: res.data.max_bet || 5000,
            bet_time: (res.data.bet_time || 15000) / 1000,
            open_bot: res.data.open_bot !== undefined ? Boolean(res.data.open_bot) : true,
            enabled: res.data.enabled !== undefined ? Boolean(res.data.enabled) : true,
          }
          this.originalConfig = JSON.parse(JSON.stringify(this.configData))
        }
      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: err.message || this.$t('error_occurred'),
        })
      }
    },
    async saveConfig() {
      if (!this.$refs.form.validate()) {
        return
      }

      // Validate percentages sum to 100
      const totalPercent = this.configData.percent_head + this.configData.percent_center + this.configData.percent_tail
      if (totalPercent !== 100) {
        this.$swal.fire({
          icon: 'error',
          title: 'ข้อผิดพลาด',
          text: `ผลรวมของเปอร์เซ็นต์ต้องเท่ากับ 100 (ปัจจุบัน: ${totalPercent})`,
        })
        return
      }

      this.saving = true
      try {
        // Convert boolean values to numbers for open_bot and enabled
        const configToSave = {
          ...this.configData,
          open_bot: this.configData.open_bot ? 1 : 0,
          enabled: this.configData.enabled ? 1 : 0,
          bet_time: this.configData.bet_time * 1000,
        }

        await this.$store.dispatch('updateGameConfig', {
          config: configToSave,
        })

        this.$swal.fire({
          icon: 'success',
          title: this.$t('save'),
          text: 'การตั้งค่าเกมได้รับการอัปเดตแล้ว',
        })

        // Reload config to get updated values
        await this.loadConfig()
      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: err.message || this.$t('error_occurred'),
        })
      } finally {
        this.saving = false
      }
    },
    resetForm() {
      if (this.originalConfig) {
        this.configData = JSON.parse(JSON.stringify(this.originalConfig))
      }
      this.$refs.form.resetValidation()
    },
  },
}
</script>
